import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const paymentApi = createApi({
    reducerPath: 'paymentApi',
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_API_URL,
        credentials: 'include',
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('_at') || null;
            if (token) {
                headers.set("Authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        initiatePayment: builder.mutation({
            query: (payload) => ({
                url: '/payment/initiate',
                method: 'POST',
                body: payload,
            }),
        }),
        verifyPayment: builder.mutation({
            query: (data) => ({
                url: `/payment/verify?data=${data}`,
                method: 'GET',
            }),
        }),
    }),
});

export const { useInitiatePaymentMutation, useVerifyPaymentMutation } = paymentApi;
